import { useEffect, useState } from "react"
import type { SelectOptionType, SuccessFetch } from "../../../../../../../../types"
import { useApi } from "../../../../../../../../utils"

export function useDoctoral() {
  const api = useApi()
  const [data, setData] = useState<SelectOptionType[]>([])
  const [isLoading, setLoading] = useState(false)
  
  const refetch = () => {
    setLoading(true)

    api.get("/doctoral/")
    .then((res: SuccessFetch<{
      payload: {
        doctoral_id: number
        doctoral_name: string
      }[]
    }>) => { setData(res.data.payload.map(item => { return { label: item.doctoral_name, value: item.doctoral_id.toString() }}))})
    .catch(() => setData([]))
    .finally(() => setLoading(false))
  }

  useEffect(() => {
    setLoading(true)

    api.get("/doctoral/").then((res: SuccessFetch<{
      payload: {
        doctoral_id: number
        doctoral_name: string
      }[]
    }>) => {
      setData(res.data.payload.map(item => {
        return {
          label: item.doctoral_name,
          value: item.doctoral_id?.toString()
        }
      }))
    }).catch(() => {
      setData([])
    }).finally(() => {
      setLoading(false)
    })
    // eslint-disable-next-line
  }, [])

  return { data, isLoading, refetch }
}